import React from 'react'
import * as classes from './hover.module.scss'

export default function Hover(props) {
    return (
        <div 
            aria-hidden="true"
            onClick={props.click} 
            className={classes.Hover + " " + (props.show ? classes.HoverShown : null)}></div>
    )
}